export const SET_MAINTENANCE_MODE_ENABLED = 'SET_MAINTENANCE_MODE_ENABLED'
export const SET_RETRY_AT = 'SET_RETRY_AT'
